import React, { Component } from 'react'
import { Modal, Spin, Icon, Button, Checkbox } from 'antd'
import { styles, texts } from './Utils'
////checker => 11111430

interface CancellationProcess {
    failed: boolean
    success: boolean
    process: boolean
    step: number
    awaitingStepsCount: number
}

interface CancelSubscriptionModalProps {
    visible: boolean
    onClose: () => void
    onAfterClose?: () => void
    handleCanceledSubscription: () => void
    // true while a confirmed flow runs: the confirmation button is disabled
    busy?: boolean
    cancellation_process: CancellationProcess
    tranzilaApproveHandler: (e: any) => void
    tranzilaApproval: boolean
    eventInitiator?: string
    subsciptionStatus?: string
    isPrepayment?: boolean
    wasPrepayment?: boolean
    isCollective?: boolean
    roles?: string[]
}
// role admin, and status not closed, subscription is not canceled
class CancelSubscriptionModal extends Component<CancelSubscriptionModalProps> {
    render() {
        const {
            visible,
            onClose,
            onAfterClose,
            cancellation_process,
            tranzilaApproval,
            handleCanceledSubscription,
            busy,
            tranzilaApproveHandler,
            eventInitiator,
            subsciptionStatus,
            roles,
            isPrepayment,
            wasPrepayment,
            isCollective
        } = this.props

        const { failed, success, process, step, awaitingStepsCount } = cancellation_process
        const preStep = step === 0
        const isAdmin = roles.includes('admin')

        const hideSecondStep = isPrepayment || wasPrepayment || isCollective
        const showSecondStep = !hideSecondStep

        // prettier-ignore
        const xVisibility = (step === awaitingStepsCount && success) || failed || preStep ? 'visible' : 'hidden'
        const boolVisibility = xVisibility === 'visible' || preStep

        const popupTitle = () => {
            if (eventInitiator === 'SUBSCRIPTION_BLOCKED') {
                return preStep ? texts.main_pre_block : texts.main_pre_block_on
            }

            if (eventInitiator === 'SUBSCRIPTION_ACTIVE' || eventInitiator === 'SUBSCRIPTION_RECOVER') {
                return preStep ? texts.main_pre_active : texts.main_pre_active_on
            }
            return preStep ? texts.main_pre : texts.main
        }
        const firstStepTitle = () => {
            if (eventInitiator === 'SUBSCRIPTION_BLOCKED') return texts.process_3_pre
            // prettier-ignore
            if (eventInitiator === 'SUBSCRIPTION_ACTIVE' || eventInitiator === 'SUBSCRIPTION_RECOVER') return texts.process_4_pre
            return preStep ? texts.process_1_pre : texts.process_1
        }

        const secondStepTitle = () => {
            // prettier-ignore
            if (eventInitiator === 'SUBSCRIPTION_ACTIVE' || eventInitiator === 'SUBSCRIPTION_RECOVER') return texts.process_5_pre

            return preStep ? texts.process_2_pre : texts.process_2
        }

        return (
            <Modal
                visible={visible}
                title={popupTitle()}
                onCancel={onClose}
                width={preStep ? '500px' : '560px'}
                bodyStyle={{
                    height: preStep ? `${100 + 30 * awaitingStepsCount}px` : `${100 + 25 * awaitingStepsCount}px`
                }}
                afterClose={onAfterClose}
                closeIcon={<span style={{ ...styles.xBtn, visibility: xVisibility }}>×</span>}
                maskClosable={isAdmin}
                footer={
                    boolVisibility && (success || failed) ? (
                        <div style={{ ...styles.footerText, color: failed ? 'red' : '' }}>
                            {failed ? texts.error_main : texts.process_done}
                        </div>
                    ) : null
                }
            >
                <div style={styles.flex_col}>
                    {/*first step*/}
                    <div style={styles.flex_row}>
                        {step === 1 && process ? <Spin size="small" /> : null}
                        {step === 1 && failed ? <Icon type="close-circle" style={styles.close_circle} /> : null}
                        {step === 2 || (!tranzilaApproval && success) ? (
                            <Icon type="check-circle" style={styles.check_circle} />
                        ) : null}
                        <div style={styles.title}>{firstStepTitle()}</div>
                    </div>

                    {/*second step*/}
                    <div
                        style={{
                            ...styles.flex_row,
                            opacity: step === 2 || preStep ? '1' : '0.3',
                            display: hideSecondStep ? 'none' : 'flex',
                            pointerEvents: hideSecondStep ? 'none' : 'auto'
                        }}
                    >
                        {showSecondStep && preStep ? (
                            <Checkbox onChange={tranzilaApproveHandler} checked={tranzilaApproval} />
                        ) : null}
                        {showSecondStep && step === 2 && process ? <Spin size="small" /> : null}
                        {showSecondStep && step === 2 && failed ? (
                            <Icon type="close-circle" style={styles.close_circle} />
                        ) : null}
                        {showSecondStep && step === 2 && success ? (
                            <Icon type="check-circle" style={styles.check_circle} />
                        ) : null}
                        {showSecondStep && <div style={styles.title}>{secondStepTitle()}</div>}
                    </div>

                    <Button
                        type="primary"
                        style={{ ...styles.preBtn, display: preStep ? 'block' : 'none' }}
                        disabled={!!busy}
                        onClick={handleCanceledSubscription}
                    >
                        {texts.btn_title}
                    </Button>
                </div>
            </Modal>
        )
    }
}

export default CancelSubscriptionModal
